module.exports = __webpack_public_path__ + "img/category-favorite.b9fb22d6.png";